import { reset, setStorage } from '../utils/vuex';
import rights from '../rights';
import i18n from '../i18n';
import vuetify from '../plugins/vuetify';

const state = {
  color: 'success',
  title: 'Komacute',
  sidebarBackgroundColor: 'rgba(27, 27, 27, 0.74)',
  rights,
  locale: localStorage.getItem('locale') || i18n.locale,
  version: process.env.PACKAGE_VERSION || '0.0.0',
  messages: [],
};

const setLocale = async (context, { $i18n, locale, $FeathersVuex }) => {
  context.commit('SET_LOCALE', locale);
  $i18n.locale = locale;
  moment.locale(locale);
  vuetify.framework.lang.current = locale;
  if ($FeathersVuex) {
    const userId = context.rootState.auth.user._id;
    const user = await $FeathersVuex.api.User.get(userId);
    if (user.locale !== locale) {
      user.locale = locale;
      user.save();
    }
  }
};

export default {
  plugin: () => {},

  store: {
    app: {
      namespaced: true,

      state,

      getters: {
        appVersion: s => s.version,
      },

      mutations: {
        clearAll: reset(state),

        SET_IMAGE: setStorage('image'),
        SET_COLOR: setStorage('color'),

        SET_LOCALE: setStorage('locale'),

        PUSH_SNACK: (stateIn, payload) => {
          if (!_.isEmpty(stateIn.messages) && _.last(stateIn.messages).level !== 'error') {
            stateIn.messages.pop();
          }
          stateIn.messages.push(payload);
        },

        POP_SNACK: stateIn => {
          stateIn.messages.pop();
        },
      },

      actions: {
        setColor(context, color) {
          context.commit('SET_COLOR', color);
        },

        setImage(context, img) {
          context.commit('SET_IMAGE', img);
        },

        setLocale(context, { $i18n, locale, $FeathersVuex }) {
          setLocale(context, { $i18n, locale: locale || 'en', $FeathersVuex });
        },

        toggleLocale(context, { $i18n, $FeathersVuex }) {
          const locale = context.state.locale === 'fr' ? 'en' : 'fr';
          setLocale(context, { $i18n, locale: locale || 'en', $FeathersVuex });
        },

        pushSnack(context, snack) {
          context.commit('PUSH_SNACK', { ...snack, id: _.uniqueId() });
        },

        popSnack(context) {
          context.commit('POP_SNACK');
        },
      },
    },
  },
};
